import { useTranslation } from 'react-i18next';

import { ReactComponent as Api } from 'assets/icons/Api.svg';
import testingConstants from 'utils/testingConstants';

const ApiKeysEmptyState = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col items-center justify-center gap-1 py-12 text-center"
      data-testid={testingConstants.apiKeysEmptyState}
    >
      <Api className="text-gray-60 stroke-1.5 mb-1 h-6 w-6 stroke-current" />
      <span className="text-grayscale-black text-sm font-medium">{t('workspaces_settings.api_keys.empty_title')}</span>
      <span className="text-gray-80 text-size-sm">{t('workspaces_settings.api_keys.empty_subtitle')}</span>
    </div>
  );
};

export default ApiKeysEmptyState;
